import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { environment } from "@environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  
  public port: string = '8080';
  //public server: string = 'http://localhost:'+this.port+"/cudi_rest_carnet/v1";
  public server: string = environment.urlBack+"cudi_rest_carnet/v1";


  constructor(private http: HttpClient) { }

  public headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'clave': environment.passwordCudi,
    'usuario': 'CUDI_APP',
    'apikey': environment.apiKey,
    'Authorization': 'Basic '+environment.apiKey,
    'mv-hide-error': 'true'
  });

  get(endpoint: string): Observable<any> {

    return this.http.get(endpoint, { headers: this.headers }).pipe(
      map((response) => {
        return response;
      })
    );
  }

  /* Método post con parámetros para las llamadas al Back */
  /**
   * Petición post con body
   * @param endpoint al que llamar.
   * @param body a enviar.
   * @returns 
   */
  post(endpoint: string, body: any): Observable<any> {

    return this.http
      .post(endpoint, body, { headers: this.headers })
      .pipe(map((response) => {
        return response;
      }));
  }
  
  postSinBody(endpoint: string, pathParms?: { key: string, value: any }[]): Observable<any> {
    return this.http
      .post(endpoint, null,  { headers: this.headers })
      .pipe(map((response) => {
        return response;
      }));
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        const jsonString = reader.result as string;
        // Dividir la cadena en líneas
        const lines = jsonString.split('\n');
        // Encontrar la línea que contiene "message"
        const messageLine = lines.find(line => line.includes('"message"'));
        // Extraer el valor de "message"
        const message = messageLine.match(/"message" : "(.*?)"/)[1];
        observer.error(message);
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
}

  
  
}
